(function ($) {
    "use strict";
    $(function () {

        var isNewsletterButtonClick = false;

        $('.js-newsletter-form').submit(function (e) {
            e.preventDefault();

            var isTemplate = $(this).data('template');

            if (isNewsletterButtonClick) {
                return false;
            }

            isNewsletterButtonClick = true;

            var $this = $(this);
            grecaptcha.ready(function () {
                grecaptcha.execute(localize.captcha_site_key, { action: 'submit' }).then(function (grecaptchatoken) {
                    $.ajax({
                        type: "post",
                        context: this,
                        dataType: "json",
                        url: localize.ajaxurl,
                        data: {
                            action: "mailchimpsubscribe",
                            datas: $this.serializeArray(),
                            grecaptchatoken: grecaptchatoken
                        },
                        success: function (response) {
                            isNewsletterButtonClick = false;



                            if (!response['fault']) {
                                $this.trigger('reset');
                                $('.js-success-messages').html(response['msg'].map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                    Fancybox.show([{
                                        src: "#general__success_modal",
                                        type: "inline",
                                        closeButton: false,
                                        hideScrollbar: true
                                    }]);
                                });

                            } else {

                                if (response['msg_type'] == "error") {

                                    if (response['error_fields'] && response['error_fields'].length > 0) {
                                        $.each(response['error_fields'], function (i, e) {
                                            if (isTemplate) {
                                                $(`#template_${e}`).parents('.form-group').addClass('has--error js-has-error')
                                            } else {
                                                $(`#${e}`).parents('.form-group').addClass('has--error js-has-error')
                                            }


                                        })
                                    }


                                    $('.js-error-messages').html(response['msg'].map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                        Fancybox.show([{
                                            src: "#general__error_modal",
                                            type: "inline",
                                            closeButton: false,
                                            hideScrollbar: true
                                        }]);
                                    });
                                }

                                if (response['msg_type'] == "warning") {
                                    $('.js-warning-messages').html(response['msg'].map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                        Fancybox.show([{
                                            src: "#general__warning_modal",
                                            type: "inline",
                                            closeButton: false,
                                            hideScrollbar: true
                                        }]);
                                    });
                                }


                            }
                        }
                    });
                })
            });

            return false;
        });

    });
})(jQuery)